import RightMenu from './RightMenu';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import { correctedSubCat, decodeCode, duplicateKey, findSimilarWoodMtl, getGoodCategories, getMaterialByID, getMaterialBySKU, getMaterialExceptions, getModelBySKU, mtlTags, woodCompatible } from '../functions';
import { DowloandIcon, ToggleSwitch } from '../Icons/Icons';
import { CreatePDF } from './PDF';
import { useMediaQuery } from 'react-responsive';
import LoadingPage from './Loading';
import InfoTooltip from './VariationHover';
import { SideListMenu } from './SideListMenu';
import { Drawer } from './Drawer';

const appVersion = "v2026-10-14";
const version3D = "v6.10.0";
const executable = false; // Avoir un menu sur le coté

document.body.dataset.version = appVersion;

export default function MainPage(props) {
    const { i18n, t } = useTranslation();
    const urlParams = new URLSearchParams(window.location.search);
    const isSmallScreen = useMediaQuery({ maxWidth: 1024 });

    const [iframe, setIframe] = useState();
    const [modelCode, setModelCode] = useState({ model: urlParams.get('model') || "LV" });
    const [model, setModel] = useState({ model: null, option: null });
    const [currMaterials, setCurrMaterials] = useState({});
    const [switchToggled, setSwitchToggled] = useState(false);
    const [category, setCategory] = useState();
    const [subCat, setSubCat] = useState({});
    const [currFilters, setCurrFilters] = useState([]);
    const [duotonChoice, setDuotonChoice] = useState("mono");
    const [activateX, setActivateX] = useState(true);
    const [maxTag, setMaxTags] = useState({});
    const [tagToRemove, setTagToRemove] = useState([]);

    const [openDrawer, setOpenDrawer] = useState(false);

    const [modelLoading, setModelLoading] = useState(true);
    const [mtlLoading, setMtlLoading] = useState(false);

    const [woodException, setWoodException] = useState("");

    const [tmpInit, settmpInit] = useState(false);
    // const [modelInit, setModelInit] = useState(false);

    useEffect(() => {
        // console.log(model)
        if (model.model && model.option) {
            const mtlExceptions = getMaterialExceptions(model);
            const tmpCat = model.model.category.filter(el => model.option.category.includes(el.id));
            // console.log(currMaterials?.wood.code)
            const goodCat = getGoodCategories(model.model.duoton, duotonChoice, tmpCat)
            let initTags = { ...maxTag };
            setCategory(goodCat);
            let woEx = [];
            const goodIDs = model.model.category
                .filter(el => el.materials.includes("wood") && (el.name.en.toLowerCase().includes("table top") || el.name.en.toLowerCase().includes("headboard")))
                .map(el => el.id);
            // Exception pour le bois pour les tables uniquement ou le lit city!
            // ⚠️ Devrait se faire automatiquement... ⚠️
            // console.log( model.model)
            if (model.model.type === "table" || model.model.SKU === "CI") {
                const hasCommon = model.option.category.some(id => goodIDs.includes(id));
                if (hasCommon && model.model.SKU !== "OB008") { // Exception OB008 (Opal Pub)
                    // console.log(model.option.SKU, goodIDs)
                    woEx = woodCompatible(model.option.SKU, model.model.SKU);
                } else {
                    woEx = [];
                }
                // console.log(woEx)
                setWoodException(woEx)
            }

            // console.log(mtlExceptions)
            mtlExceptions.forEach(mt => {
                const mtl = getMaterialByID(props.db.materials, mt);
                // console.log(mtl)

                // Exception avec noyer solid 
                // ⚠️ À CHANGER S'IL Y A PLUS D'UN NOYER MASSIF!!! ⚠️
                if(mtl.tags.includes("bn") && mtl.tags.includes("sw")){
                    initTags.bn = 0;
                }
                mtl.tags.forEach(t => {
                    initTags[t]--;
                })
            })
            // console.log(initTags, maxTag)
            const removeTags = Object.entries(initTags).filter(([k, v]) => v <= 0).map(([key]) => key);
            setTagToRemove(removeTags);
            goodCat?.map((el, i) => {
                // console.log(el)
                // const catID = !isDuoton && (el.materials?.includes("fabric") || el.materials?.includes("leather")) && zeModel.type === "bed" ? el.id : "";
                // console.log(el.materials)
                const currMtlCorrected = Object.entries(currMaterials).map(([k, v]) => ({ [k.replace(/\d+/g, "")]: getMaterialBySKU(props.db.materials, v.code) }));
                // const currMtlCorrected = Object.keys(currMaterials).map(str => str.replace(/\d+/g, ""));
                const validMtl = goodIDs.includes(el.id);
                // console.log(model.model)
                const correctedCat = correctedSubCat(el.materials, validMtl ? woEx : [], removeTags);
                // console.log(correctedCat, woEx, removeTags, initTags)
                // const tags = correctedCat;
                // console.log(currMtlCorrected, correctedCat)
                // const car = correctedCat.find(l=>{

                //     return(

                //     )
                // })

                if (correctedCat.length > 0) {
                    const id = el.id + 1;
                    const cat = correctedCat.find(c => {
                        const tagObj = mtlTags[c];
                        if (!tagObj || !tagObj.id) return false;         // pas de tag connu => skip

                        const tagId = tagObj.id;                         // ex: "pf"
                        const base = c.split("_")[0];                    // ex: "fabric"

                        const obj = currMtlCorrected.find(it => Object.keys(it)[0] === base);
                        if (!obj) return false;

                        const key = Object.keys(obj)[0];
                        const tags = obj[key]?.tags || [];

                        return tags.includes(tagId);
                    });
                    // console.log(woEx, cat, !cat && woEx !== "")

                    // If material not compatible -> set another one
                    // console.log(cat, woEx, !cat,woEx !== "")
                    if (!cat && woEx.length > 0) {
                        // Temporaire, le temps de créer une mécanique plus propre --> garder la même teinte de bois => Meriser Fog -> Chêne Fog
                        // console.log(currMaterials.wood?.code, woEx.split("_")[1])
                        const goodWood = findSimilarWoodMtl(props.db.materials, currMaterials.wood?.code, woEx)
                        // console.log(goodWood, model,)
                        setCurrMaterials(el => ({ ...el, wood: { code: goodWood.SKU, rotation: model.model.orientation?.[goodWood.id] || goodWood.orientation || 0 } }))
                        // iframe.setMaterial("wood", goodWood.SKU);
                    }

                    // console.log(woEx)
                    // const newSubCat = {cat, show:, hide:};
                    setSubCat(sub => ({ ...sub, [id]: validMtl && woEx.length > 0 ? woEx[0] : cat }))
                }
            })
        }
    }, [model, duotonChoice])

    function handleDimensions() {
        if (switchToggled) {
            // Si c'était activé, on désactive
            iframe.showHideMeasures(false);
        } else {
            // Si c'était désactivé, on active avec les dimensions du modèle
            iframe.showHideMeasures({
                x: model.option.dimension.width,
                y: model.option.dimension.length,
                z: model.option.dimension.heigth,
            });
        }

        // On inverse l'état du switch
        setSwitchToggled(prev => !prev);
    }
    // useEffect(() => {
    //     if (subCat) {
    //         console.log(subCat)
    //     }
    // }, [subCat]);

    useEffect(() => {
        if (model?.model && model?.option && switchToggled) {
            // Si le modèle change et que le switch est ON, on met à jour les dimensions
            iframe.showHideMeasures({
                x: model.option.dimension.width,
                y: model.option.dimension.length,
                z: model.option.dimension.heigth,
            });
        }
    }, [model, switchToggled]);

    useEffect(() => {
        urlParams.get('lang') && i18n.changeLanguage(urlParams.get('lang').toLowerCase());
    }, [])

    const AppLoaded = () => {
        //-------------------------------------------------------------------------------------------------------------------------------------//
        // Debug pour avoir un array pour tester l'app
        // console.log(
        //     props.db.furnitures
        //         .map(el => ({
        //             SKU: el.SKU,
        //             name: el.name,
        //             type: t(el.type),
        //             new: el.isNew
        //         }))
        //         .sort((a, b) => {
        //             // D’abord, on compare les types
        //             const typeCompare = a.type.localeCompare(b.type);
        //             if (typeCompare !== 0) return typeCompare;
        //             // Si les types sont identiques, on compare les noms
        //             return a.name.localeCompare(b.name);
        //         })
        // );
        //-------------------------------------------------------------------------------------------------------------------------------------//

        // ----------------- Set max tags ---/
        const tagsCounts = {};
        props.db.materials.forEach((material) => {
            if (Array.isArray(material.tags)) {
                material.tags.forEach((tag) => {
                    tagsCounts[tag] = (tagsCounts[tag] || 0) + 1;
                });
            }
        });
        setMaxTags(tagsCounts);
        //-----------------------------------/

        let zeModel = modelCode.model;
        let zeOption = modelCode.option;
        let zeDuo = duotonChoice;
        let zeMaterials;
        if (urlParams.get('code')) {
            setActivateX(false);
            const code = urlParams.get('code');
            let decodedCode = decodeCode(code);
            // console.log(decodedCode)
            zeModel = decodedCode.model.model;
            zeOption = decodedCode.model.option;
            zeDuo = decodedCode.duotonChoice;
            zeMaterials = decodedCode.materials;
            setModelCode({ model: zeModel, option: zeOption })
            setDuotonChoice(zeDuo);
        }

        const mod = getModelBySKU(props.db.furnitures, zeModel, zeOption);
        // console.log(zeMaterials)
        let mtls;
        if (zeMaterials) {
            mtls = Object.fromEntries(
                Object.entries(zeMaterials).map(([key, value]) => [
                    key,
                    getMaterialBySKU(props.db.materials, value)
                ])
            );
        } else {
            mtls = Object.fromEntries(
                Object.entries(mod.model.default)
                    .filter(([_, value]) => value.default === true)
                    .map(([key, value]) => [
                        key,
                        getMaterialByID(props.db.materials, value.material)
                    ])
            );
        }
        // console.log(mod.model.orientation,mtls)
        const orientation = 0;
        let mtlsIframe = Object.fromEntries(Object.entries(mtls).filter(([k, v]) => v !== undefined).map(([k, v]) => [k, { code: v.SKU, rotation: mod.model?.orientation?.[v.id] || v.orientation || 0 }]))
        // console.log(mtlsIframe)
        if (mod.model.duoton && zeDuo !== "mono" && !urlParams.get('code')) {
            // mtlsIframe
            const goodFab = Object.keys(mtlsIframe).includes("fabric") ? "fabric" : "leather";
            mtlsIframe = duplicateKey(mtlsIframe, goodFab)
        }
        // console.log(mod)

        // console.log(mtlsIframe)
        setCurrMaterials(mtlsIframe)
        setModel(mod);
        // console.log(mod.model?.SKU, mod.option, mtlsIframe, zeDuo)
        iframe.loadModel(mod.model.SKU, mod.option.SKU, mtlsIframe, zeDuo);
        // setModelInit(true);
    }

    useEffect(() => {
        if (model?.model?.duoton && tmpInit) {
            let mtlsIframe = { ...currMaterials };
            if (duotonChoice === "mono") {
                delete mtlsIframe.fabric2;
                delete mtlsIframe.leather2;
                mtlsIframe.fabric = mtlsIframe.fabric1 ?? mtlsIframe.fabric;
                mtlsIframe.leather = mtlsIframe.leather1 ?? mtlsIframe.leather;
                delete mtlsIframe.fabric1;
                delete mtlsIframe.leather1;
                if (!mtlsIframe.leather) {
                    delete mtlsIframe.leather
                }
                if (!mtlsIframe.fabric) {
                    delete mtlsIframe.fabric
                }
            } else {
                const goodFab = Object.keys(mtlsIframe).includes("fabric") ? "fabric" : "leather";
                mtlsIframe = duplicateKey(mtlsIframe, goodFab)
            }
            setCurrMaterials(mtlsIframe);
            // console.log(model.model.SKU, model.option.SKU, mtlsIframe, duotonChoice)
            iframe.loadModel(model.model.SKU, model.option.SKU, mtlsIframe, duotonChoice);
            // console.log(duotonChoice)
            // const goodFab = Object.keys(mtlsIframe).includes("fabric") ? "fabric" : "leather";
            // mtlsIframe = duplicateKey(mtlsIframe, goodFab)
        }
    }, [duotonChoice])

    function OnModelBegin() {
        setModelLoading(true)
    }
    function OnModelEnd() {
        setModelLoading(false)
    }
    function OnMaterialBegin() {
        setMtlLoading(true)
    }
    function OnMaterialEnd() {
        setMtlLoading(false)
    }

    useEffect(() => {
        if (iframe) {
            iframe.addEventListener("initiatedApp", AppLoaded, false);
            iframe.addEventListener("OnPDF", generatePDF, false);
            iframe.addEventListener("onModelBegin", OnModelBegin, false);
            iframe.addEventListener("onModelEnd", OnModelEnd, false);
            iframe.addEventListener("onMaterialBegin", OnMaterialBegin, false);
            iframe.addEventListener("onMaterialEnd", OnMaterialEnd, false);
        }
        return () => {
            if (iframe) {
                iframe.removeEventListener("initiatedApp", AppLoaded);
                iframe.removeEventListener("OnPDF", generatePDF);
                iframe.removeEventListener("onModelBegin", OnModelBegin);
                iframe.removeEventListener("onModelEnd", OnModelEnd);
                iframe.removeEventListener("onMaterialBegin", OnMaterialBegin);
                iframe.removeEventListener("onMaterialEnd", OnMaterialEnd);
            }
        }
    }, [iframe, model, currMaterials, category, currFilters, duotonChoice])

    useEffect(() => {
        if (modelCode && tmpInit) {
            // console.log(modelCode)
            const mod = getModelBySKU(props.db.furnitures, modelCode.model, modelCode.option);
            const mtlExceptions = getMaterialExceptions(mod);
            // let newMtls = { ...currMaterials }

            // Check if material is valid
            setCurrMaterials(prev => {
                let newMtls = { ...prev };
                // console.log(newMtls)

                for (let [mtK, mtV] of Object.entries(prev)) {
                    // console.log(mtV)
                    let mtlID = getMaterialBySKU(props.db.materials, mtV.code).id;
                    if (mtlExceptions.includes(mtlID)) {
                        // if (mtK === "wood") {
                        //     const woodTag = woodCompatible(mod.option.SKU);
                        //     const newWood = findSimilarWoodMtl(props.db.materials, mtV.code, woodTag.split("_")[1]);
                        //     console.log(newWood)
                        // } else {
                        const validMtl = mod.model.default[mtK].material;
                        if (validMtl) {
                            newMtls[mtK] = { code: getMaterialByID(props.db.materials, validMtl).SKU };
                        }
                        // }
                    }
                }
                setModel(mod);
                iframe.loadModel(modelCode.model, modelCode.option);
                // console.log(newMtls)
                return newMtls;
            });
            // console.log(modelCode, newMtls)
        }
    }, [modelCode])

    useEffect(() => {
        if (currMaterials) {
            // console.log(currMaterials)
            iframe?.setMaterials(currMaterials);
        }
    }, [currMaterials])

    // useEffect(() => {
    //     if (currMaterials) {
    //         console.log(currMaterials)
    //     }
    // }, [currMaterials])

    function generatePDF(evt) {
        // console.log(evt)
        const image = evt.detail;
        console.warn("Création du PDF...");
        // console.log(model)
        CreatePDF(model, currMaterials, props.db.materials, category, currFilters, image, duotonChoice);
    }

    const tmpModelName = model.model?.name ? model.model?.name?.split(" | ") : [];
    const goodModelName = i18n.language === "fr" ? tmpModelName?.[0] : tmpModelName?.[1] || tmpModelName?.[0];

    return (
        <div id='app'>
            {(modelLoading || mtlLoading) && <LoadingPage />}
            <div id="mainApp">
                {/* Side menu for demo only */}
                {executable && <SideListMenu AppLoaded={AppLoaded} settmpInit={settmpInit} modelCode={modelCode} setModelCode={setModelCode} db={props.db} />}
                <div id="theApp">
                    <div className='topTitles'>
                        <h2>{goodModelName}</h2>
                        <h6>{t(model.model?.type)}</h6>
                    </div>
                    <div id='buttons'>
                        <div className='PDF' onClick={() => iframe.makePDF()}>
                            <DowloandIcon />
                            <h5>{t("PDFdownload")}</h5>
                        </div>
                        <div className='switch' onClick={() => handleDimensions()}>
                            <ToggleSwitch toggled={switchToggled} />
                            <h5>{t("showDimensions")}</h5>
                        </div>
                        <InfoTooltip />
                    </div>
                    <div id="iframeContainer">
                        <a id="logoEdge" target='_blank' href={'https://edgedimension.com/' + i18n.language}>
                            <img src={'./images/logo-edge_' + i18n.language + '.png'} />
                        </a>
                        {(modelLoading || mtlLoading) && <div id="loadingHider"></div>}
                        <iframe id="appIframe" onLoad={(e) => setIframe(e.target.contentWindow)} src={'./app/' + version3D + '/index.html'} loading="lazy" ></iframe>
                    </div>
                    {/* Drawer popup */}
                    <Drawer
                        openDrawer={openDrawer}
                        setOpenDrawer={setOpenDrawer}
                        appVersion={version3D}
                        currMaterials={currMaterials}
                        model={model}
                    />
                </div>
            </div>
            {
                model.model && <RightMenu
                    iframe={iframe}
                    data={props.db}
                    model={model}
                    currMaterials={currMaterials}
                    setCurrMaterials={setCurrMaterials}
                    setModelCode={setModelCode}
                    category={category}
                    setCategory={setCategory}
                    subCat={subCat}
                    setSubCat={setSubCat}
                    currFilters={currFilters}
                    setCurrFilters={setCurrFilters}
                    isSmallScreen={isSmallScreen}
                    tmpInit={tmpInit}
                    settmpInit={settmpInit}
                    duotonChoice={duotonChoice}
                    setDuotonChoice={setDuotonChoice}
                    woodException={woodException}
                    activateX={activateX ? !executable : activateX}
                    tagToRemove={tagToRemove}
                    openDrawer={openDrawer}
                    setOpenDrawer={setOpenDrawer}
                />
            }
            <div className='PDF mobile' onClick={() => iframe.makePDF()}>
                <DowloandIcon />
                <h5>{t("PDFdownload")}</h5>
            </div>
        </div >
    )
}